import React from "react";
import {
  Dialog,
  DialogTitle,
  TextField,
  DialogContent, 
  DialogActions, 
  Button
} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';

class UnitForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      unit: {
        id: null,
        name: '',
        short: ''
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.unit !== prevProps.unit)  {
        if(this.props.unit !== null){
            this.setState({
                unit: this.props.unit
            })
        } else {
            this.setState({
                unit: {
                    id: null,
                    name: '',
                    short: ''
                  }
            })
        }
    }
  }

  render(){
    const { classes, theme, openForm, nameForm, submitAction, cancelAction, unit } = this.props;
    return (
      <React.Fragment>
     
      {openForm &&
        <Dialog open={openForm} onClose={() => cancelAction()}>
          <DialogTitle id="form-dialog-title">{nameForm}</DialogTitle>
            <DialogContent>
              <TextField
                margin="dense"
                id="name"
                label="Название"
                onChange={(e)=>{
                        this.setState({
                            unit: {
                                ...this.state.unit,
                                name: e.target.value
                            }
                        })
                    }
                }
                value={this.state.unit.name}
                fullWidth
              />
              <TextField
                margin="dense"
                id="short"
                label="Сокращенное название"
                onChange={(e)=>{
                    this.setState({
                        unit: {
                            ...this.state.unit,
                            short: e.target.value
                        }
                    })
                }}
                value={this.state.unit.short}
                fullWidth
              />
              
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{cancelAction()}} color="secondary">
                Отмена
              </Button>
              <Button onClick={()=>{submitAction(this.state.unit);}} color="primary">
                Сохранить
              </Button>
            </DialogActions>
      </Dialog>
      }
      </React.Fragment>
    );
  }
}
const styles = theme => ({
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
});

export default withStyles(styles, { withTheme: true })(UnitForm);
